import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
// utils
import { Translations, convertStringToArray } from '../../../utils/';
// restClient
import { aemHostClient, taxonomyHostClient } from '../../../restClient';
// children
import NavigationList from '../../common/NavigationList/';
//action Creator
import { deleteProduct } from '../actions/actionCreator';
import { setDarkTitleBarContent } from '../../layouts/actions/actionCreator';
//style
import './styles.less';

const AddEchannel = (props) => {
  const [pageJson, setPageJson] = useState();
  const [currentListCountries, setCurrentListCountries] = useState();

  const translateWord = (word) => {
    var currentWord = Translations(word, props.lang.currentLang.lang, props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  const translations = (text) => {
    return Translations(text, props.lang.currentLang.lang, props.lang.translatedData)
  }

  useEffect(() => {
    (async () => {
      const { data } = await aemHostClient("/aemData/formData/json_echannel");
      document.title = `${Translations(data.par.page_title_mainTitle.pageHeading, props.lang.currentLang.lang, props.lang.translatedData)} - ${'HSBC GLCM'}`;
      setPageJson(data)
    })();

    (async () => {
      const { data } = await aemHostClient("/aemData/formData/json_dark-title-bar");
      props.setDarkTitleBarContent(translations(data.par.static_text_darkTitleBar.createCase), true, translations(data.par.static_text_darkTitleBar.caseList), undefined, undefined);
    })();

  }, []);

  useEffect(() => {
    props.updateBreadCrumbsState(3);
    if (pageJson && pageJson.par) {
      (async () => {
        const { data } = await taxonomyHostClient(translations(pageJson.par.navigation_list_eChannelList.countryTaxonomy));
        setCurrentListCountries(data.responseData.classificationNodes)
      })();
    }

    // for (var elementkey in pageJson.par) {
    //   if (elementkey.startsWith('label_button')) {
    //     setState({
    //       btntxt: pageJson.par[elementkey]['nav-btn'].text
    //     });
    //   }
    // }
  }, [pageJson]);

  const topreviouspage = () => {
    props.history.push("/create-a-case/add-account");
  }
  const toNextpage = () => {
    props.history.push("/create-a-case/add-gls-product");
  }
  const finish = () => {
    props.history.push('/case-body')
  }

  useEffect(() => {
    if (pageJson && pageJson.par) {
      (async () => {
        const { data } = await taxonomyHostClient(translations(pageJson.par.navigation_list_eChannelList.countryTaxonomy));
        setCurrentListCountries(data.responseData.classificationNodes)
      })();
    }
  }, [props.lang.currentLang.lang]);

  const createNewProduct = () => {
    props.history.push("/create-a-case/create-new-echannel");
  }


  let jsx = (<h3>Loading.....</h3>);
  if (pageJson) {
    const title = pageJson.par.page_title_mainTitle;
    const deleteEchannelModal = pageJson.par.modal_deleteEchannelModal;
    jsx = (
      <div className="selectcustomercontainer">
        <h2>{translations(title.pageHeading)}</h2>
        <div className="row accountcontainer">
          <div className="col-lg-10 leftcontent echanneldLft">
            <p>{translations(title.descriptionText)}</p>
          </div>
          <div className="col-lg-2 rgtcontt echanneldrgt">
            <button className="btn btn-primary btnaddwrapper" id="addNewEchannel" onClick={createNewProduct}><span className="icon icon-add addicon"></span>{translations(pageJson.par.button_addNewEChannels.text)}</button>
          </div>
        </div>
        <NavigationList cases={props.cases}
          deleteProduct={props.deleteProduct}
          countryList={currentListCountries}
          pageJson={pageJson}
          history={props.history}
          listtype="echannelVersion"
          deleteModalContent={deleteEchannelModal || {}}
          pageReferer="echannelPage" />
        <div id="btnwrapperid" className={Object.keys(props.cases).length === 0 ? 'btnWrapper addaccountbtn' : 'btnWrapper setbtnpadd'}>
          <div className="leftbtn">
            <button
              onClick={topreviouspage}
              id="disabledpreviousbtn"
              style={{ paddingTop: '10px' }}
              className={Object.keys(props.cases).length === 0 ? 'btn btn-primary btndisable btnpmg' : 'btn btn-primary btnpmg'}
            >
              <b>{translations(pageJson.par.button_previous.textPrevious)}:</b> {translations(pageJson.par.button_previous.text)}
            </button>
          </div>
          <div className="rightbtn">
            <button id="disabledFinsh" onClick={finish} className='btn btn-primary btnmrg'>{translations(pageJson.par.button_finish.text)}</button>
            <button onClick={toNextpage} id="disablednextbt" className='btn btn-primary btnbg'><b>{translations(pageJson.par.button_nextGLS.textNext)}:</b> {translations(pageJson.par.button_nextGLS.text)}</button>
          </div>
        </div>
      </div>
    )
  };
  return (
    <div>
      {jsx}
    </div>
  );

}

const mapStateToProps = state => {
  return {
    cases: state.cases,
    lang: state.lang
  }
}

const mapDispatchToProps = dispatch => {
  return {
    deleteProduct: (caseId, productType, productId) => {
      dispatch(deleteProduct(caseId, productType, productId))
    },
    setDarkTitleBarContent: (...args) => {
      dispatch(setDarkTitleBarContent(...args))
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(AddEchannel);



// WEBPACK FOOTER //
// ./src/components/createAcase/AddEchannel/index.js